module.exports = __webpack_public_path__ + "static/media/empty.a4fe6731.png";